<template>
  <div class="getCashResult">
    <job-header-simple header_title="提现"></job-header-simple>
    <article>
      <div class="header" v-if="info.status == 0">
        <van-icon name="clear" size="2rem" color="#f07362" />
        <p>提现失败</p>
      </div>
      <div class="header" v-if="info.status == 1">
        <van-icon name="checked" size="2rem" color="#6275f0" />
        <p>提现成功</p>
      </div>
      <div class="list">
        <div class="item"> 提现金额： <div class="value">
            <span class="text-theme">￥{{info.amount}}</span>({{info.company}})
          </div>
        </div>
        <div class="item"> 到账账户： <div class="value">
            <span class="text-dark">{{info.accountType}}</span>({{info.accountNo}})
          </div>
        </div>
        <div class="item" v-if="info.status == 0"> 失败原因： <div class="value">
            <span class="text-red">{{info.reason}}</span>
          </div>
        </div>
        <div class="item" v-if="info.status == 1"> 当前余额： <div class="value">
            <span class="text-dark">￥{{info.leftAmount}}</span>
          </div>
        </div>
      </div>
    </article>
    <div class="btn">
      <van-button type="info" block round to="/salary">完成</van-button>
    </div>
  </div>
</template>

<script>
import { Button, Field, Toast, Icon, Notify } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import { getOcompanyBalance } from "@/api/emolument/request";
import api from "@/api/list";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Notify.name]: Notify,
    jobHeaderSimple,
  },
  data() {
    return {
      info: {
        status: this.$route.params.status, //1 成功   0 失败，
        amount: this.$route.params.amount,
        company: this.$route.params.ocompanyName,
        accountType: "支付宝",
        accountNo:this.$route.params.account,
        reason:  this.$route.params.reason,
        leftAmount:  0.0,
      },
    };
  },
  created() {
    this.initOcompanyBalance();
  },
  methods: {
    initOcompanyBalance(){
      getOcompanyBalance().then((res) => {
        if (res.data.status == "200" && res.data.data){
        this.ocompanyAmountList = res.data.data;
        let totalBalance = 0;
        if (res.data.data != null) {
          this.ocompanyAmountList.forEach(function (obj) {
            totalBalance += parseFloat(obj.balance);
          });
        }
        let balance = totalBalance.toFixed(2);
        this.info.leftAmount =balance;
      }
    });
    } ,
  }
};
</script>

<style lang="less" scoped>
.getCashResult {
  padding: 8px;
  border-radius: 6px;
  article {
    background: #fff;
    padding: 0.8rem;
    .header {
      text-align: center;
      font-size: 0.4267rem;
      margin-bottom: 40px;
      p{
        margin-top: 12px;
      }
    }
  }
  .list {
    .item {
      color: #999;
      font-size: 0.4rem;
      line-height: 0.8rem;
      margin-bottom: 0.1333rem;
      overflow: hidden;
      .value {
        float: right;
        .text-theme {
          color: #6275f0;
        }
        .text-dark {
          color: #333;
        }
        .text-red {
          color: #f07362;
        }
      }
    }
  }

  .btn {
    padding: 50px;
  }
}
</style>